import { InjectionToken } from '@angular/core';
import type { EnvironmentType } from './environment.type';

export const Environment = new InjectionToken<EnvironmentType>('ENVIRONMENT');
